import * as CookieService from '@classic/Foundation/Services/CookieService'
import React from 'react'
import { ExpandableToolboxSection } from '../Toolbox'

export const CookieInfo = () => {
  const webappVersion = React.useMemo(
    () => CookieService.getCookieValue('webapp-version') ?? 'Not found',
    []
  )
  const allowExternalAccess = React.useMemo(
    () => CookieService.getCookieValue('allow-external-access') ?? 'Not found',
    []
  )
  return (
    <ExpandableToolboxSection heading='Cookie Info'>
      <dl>
        <dt>Webapp Version:</dt>
        <dd>
          <span>{webappVersion}</span>
        </dd>
        <dt>Allow External Access</dt>
        <dd>
          <span>{allowExternalAccess}</span>
        </dd>
      </dl>
    </ExpandableToolboxSection>
  )
}
